import { render, staticRenderFns } from "./TimeOffIndividualAllowances.vue?vue&type=template&id=3fbf0159&"
import script from "./TimeOffIndividualAllowances.vue?vue&type=script&lang=js&"
export * from "./TimeOffIndividualAllowances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports